import Vue from 'vue'
import FixedElement from '@/directives/fixedElement'

Vue.use(FixedElement)